import React from 'react';

const SvgTimerOff = props => (
	<svg width={40} height={40} {...props}>
		<g fill="#FFF" opacity={0.4} transform="translate(4 2)">
			<path d="M15.87 4.22C7.105 4.22 0 11.325 0 20.09c0 8.765 7.105 15.87 15.87 15.87 8.765 0 15.87-7.105 15.87-15.87 0-8.765-7.105-15.87-15.87-15.87zm0 2.18c7.56 0 13.69 6.13 13.69 13.69s-6.13 13.69-13.69 13.69S2.18 27.65 2.18 20.09 8.31 6.4 15.87 6.4z" />
			<path d="M21.163 13.326a1.09 1.09 0 0 1 1.675 1.39l-.08.098-5.97 6.4a1.09 1.09 0 0 1-1.676-1.39l.08-.098 5.97-6.4z" />
			<circle cx={15.87} cy={20.09} r={2.7} />
			<path d="M15.42.1a1.09 1.09 0 0 1 1.084.971l.006.119v3.97a1.09 1.09 0 0 1-2.174.119l-.006-.119V1.19c0-.602.488-1.09 1.09-1.09z" />
			<path d="M18.55 0a1.09 1.09 0 0 1 .119 2.174l-.119.006h-6.26a1.09 1.09 0 0 1-.119-2.174L12.29 0h6.26zm8.611 6.477a1.09 1.09 0 0 1 1.623 1.45l-.085.096-1.9 1.89a1.09 1.09 0 0 1-1.623-1.45l.085-.096 1.9-1.89z" />
		</g>
	</svg>
);

export default SvgTimerOff;
